import React, {useRef} from "react";

// icons : feather
import FeatherIcon from "feather-icons-react";

export default function AppFormikInputFieldRadio(props) {
  const {
    id,
    formik,
    stFormClass,
    labelName,
    labelNameRight,
    isRequired,
    isDisabled = false,
    formikFieldName,
    isRound,
    value,
    onChange = () => { }
  } = props;

  // refs
  const inputRef = useRef(null)

  return (
    <div
      className={`st-form ${stFormClass || ""} ${formik?.touched[formikFieldName] && formik?.errors[formikFieldName]
        ? "has-msg msg-error"
        : ""
        }`}
    >
      {labelName ? (
        <label className="cursor-pointer ms-2 mb-0" onClick={ev => {
          ev.preventDefault()
          inputRef?.current?.click()
        }}>
          {labelName}
          {isRequired && <span className="required ms-1 st-fs-12">(required)</span>}
        </label>
      ) : null}
      <div
        className="media-body"
        style={{ textAlign: "left" }}
      >
        <label
          className={`st-checkbox st-checkbox-primary d-inline-flex cursor-pointer position-relative ${isRound ? "rounded-circle" : ""
            }`}
          style={{ top: 2 }}
        >
          <input
            {...formik?.getFieldProps(formikFieldName)}
            type="checkbox"
            id={id}
            className="d-none"
            disabled={isDisabled}
            checked={value || ("" + formik?.values[formikFieldName] === "1")}
            ref={inputRef}
            onChange={(e) => {
              onChange(e)
              formik?.setFieldValue(
                formikFieldName,
                "" + formik?.values[formikFieldName] === "1" ? "0" : "1"
              );
            }}
          />
          <span className="box d-flex align-items-center justify-content-center border">
            <FeatherIcon
              icon="check"
              size="16"
              className="icon position-relative"
            />
          </span>
          {labelNameRight ? (
            <label className="cursor-pointer ms-2 mb-0" style={{marginTop: 2}} onClick={ev => {
              ev.preventDefault()
              inputRef?.current?.click()
            }}>
              {labelNameRight}
              {isRequired && <span className="required ms-1 st-fs-12">(required)</span>}
            </label>
          ) : null}
        </label>
        {
          /* form message */
          formik?.touched[formikFieldName] && formik?.errors[formikFieldName] && (
            <div
              className="st-form-msg position-absolute"
              style={{ bottom: -18 }}
            >
              <p className="st-fs-12">{formik?.errors[formikFieldName]}</p>
            </div>
          )
        }
      </div>
    </div>
  );
}
